import { colors } from "./index";

export const easingSeconds = "0.6s";
export const zIndexTop = 9999;
export const mobileHeaderHeight = 60;
export const desktopHeaderHeight = 154;
export const scrollToDesktopNoHero = 35;
export const scrollToDesktopWithHero = 100;
export const scrollToTabletWithHero = 75;
export const scrollToMobileWithHero = 50;
export const scrollToDesktopHeroSearchBar = 300;
export const scrollToTabletHeroSearchBar = 300;
export const scrollToMobileHeroSearchBar = 170;
export const boxShadow = "0px 1px 2px rgba(0, 0, 0, 0.164336)";
export const deviceTapColor = "rgba(2,37,207, .10)";
export const focusBorder = `border: 3px solid ${colors.focus}`;
// ^^ this focusBorder const may need to be changed to an outline so it takes the shape of whatever is using it in the future. there can be some issues with using a border for focus, such as with a custom radio button, etc.
